import * as React from "react";
import { Category } from "../../../../../Wrap/Constants/Enums/Documents/Category";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { ManagedFundsRebateType } from "../../../../../Wrap/Constants/Enums/ManagedFundsRebateType";
import { CoachMarkerSetType } from "../../../../../Wrap/Models/Models/CoachMarkers/CoachMarkerSetType";
import { CoachMarkerStepPosition } from "../../../../Shared/CoachMarkers/CoachMarker";
import { ICoachMarkerPageConfig } from "../../../../Shared/CoachMarkers/CoachMarkerContext";
import { AbacusIcon } from "../Components/Icons/AbacusIcon";
import { AnalyticsIcon } from "../Components/Icons/AnalyticsIcon";
import { CappedDrawdownCalculatorIcon } from "../Components/Icons/CappedDrawdownCalculatorIcon";
import { FundResearchIcon } from "../Components/Icons/FundResearchIcon";
import { MyFolioIcon } from "../Components/Icons/MyFolioIcon";
import { PensionForwardCalculatorIcon } from "../Components/Icons/PensionForwardCalculatorIcon";
import { RiskQuestionnaireIcon } from "../Components/Icons/RiskQuestionnaireIcon";

export enum ToolAndLiteratureTab {
    Tool = "Tools",
    Literature = "Literature",
}

export interface ToolContentProps {
    title: string;
    content: string;
    link: string;
    type?: string;
    href?: string;
    icon: any;
}
export enum FundDataType {
    Overview = "Overview",
    Charges = "Charges",
    Tradeable = "Tradeable",
}

export const ToolContent: ToolContentProps[] = [
    {
        title: "Capital gains scenario tool (CGST)",
        content:
            "Allow you to calculate gains and loss on sales of Personal Portfolio investments, model scenarios and assess the impact of different withdrawal strategies.",
        link: "Launch CGST",
        type: "CGST",
        icon: <AbacusIcon />,
    },
    {
        title: "Fund research",
        content:
            "Search for funds by fund name or fund code and view the fund price, performance, ratings, charges and links to full fund information.",
        link: "Launch Fund research",
        type: "IST",
        icon: <FundResearchIcon />,
    },
    {
        title: "MyFolio lookthrough",
        content:
            "The MyFolio Lookthrough Tool has been designed to enable you to access performance, the latest fund updates and commentary quickly and easily, with options for flexible fund charting and creating customised client reports.",
        link: "Launch MyFolio lookthrough",
        href: "https://www.abrdn.com/en-gb/platform-adviser/tools/lookthrough",
        icon: <MyFolioIcon />,
    },
    {
        title: "Capped drawdown calculator",
        content:
            "This calculator helps you work out the maximum income your client could take from their pension pot if they started capped drawdown income review, now. This is not a quote and the actual maximum permitted income amount may be different to the figure shown.",
        link: "Launch capped drawdown calculator ",
        href: "https://www.abrdn.com/en-gb/platform-adviser/tools/capped-drawdown-calculator",
        icon: <CappedDrawdownCalculatorIcon />,
    },
    {
        title: "Pension carry forward calculator",
        content:
            "This calculator works out how much pension annual allowance your client has available for a tax year (including any unused allowance carried forward from earlier years). This will help you work out how much can be paid into your client's pension without triggering an annual allowance tax charge.",
        link: "Launch pension carry forward calculator",
        href: "https://www.abrdn.com/en-gb/platform-adviser/tools/pension-carry-forward-calculator",
        icon: <PensionForwardCalculatorIcon />,
    },
];

export const DocTypeArray = [
    Category.NotSpecified,
    Category.Forms,
    Category.KeyFeatureKeyInformationDocuments,
    Category.Guides,
    Category.TermsAndConditionsPolicyProvisions,
];

export const ManagedFundsRebateTypeMap = {
    [ManagedFundsRebateType.NotSpecified]: "",
    [ManagedFundsRebateType.Bundled]: "Bundled",
    [ManagedFundsRebateType.Clean]: "Clean",
    [ManagedFundsRebateType.SuperClean]: "Super Clean",
};

export const ProductTypeMap = {
    [ProductType.NotSpecified]: "",
    [ProductType.Cash]: "Cash",
    [ProductType.Equity]: "Equity",
    [ProductType.ManagedFund]: "Managed Fund",
    [ProductType.Bond]: "Bond",
    [ProductType.ModelPortfolio]: "Model Portfolio",
    [ProductType.AdviserModelPortfolio]: "Adviser Model Portfolio",
    [ProductType.ManagedModelPortfolio]: "Managed Model Portfolio",
    [ProductType.TailoredModelPortfolio]: "Tailored Model Portfolio",
};

export const DocTypeMap = {
    [Category.NotSpecified]: "All",
    [Category.Forms]: "Forms",
    [Category.Guides]: "Guides",
    [Category.KeyFeatureKeyInformationDocuments]: "Key features & Key Information documents",
    [Category.TermsAndConditionsPolicyProvisions]: "Terms and Conditions & Policy Provisions",
};

export const literatureCoachmarkerConfig: ICoachMarkerPageConfig = {
    coachMarkerSetType: CoachMarkerSetType.FnzOneLiterature,
    steps: [
        {
            title: "Favourites",
            stepPosition: CoachMarkerStepPosition.BottomLeft,
            stepKey: "literature-favourites",
            positionTop: 47,
            positionLeft: -329,
            description: (
                <>
                    Create a list of your favourite and most used documents by selecting the star icon next to a
                    document name. Quickly and easily view your favourites shortlist by selecting this button.
                </>
            ),
        },
    ],
};
